<template>
  <!--
    // A -> xzs
    // D -> 2020.04.20
    // F -> 封装简历组件
  -->
  <div class="details" :data="data">
    <section class="details-a">
      <h1>个人信息</h1>
      <div class="userIf-box">
        <img class="userIf-left" :src="data.avatar" />
        <div class="userIf-right">
          <span data-name="姓名：" :title="data.name">{{ data.name }}</span>
          <span data-name="性别：" :title="data.sex_name">{{
            data.sex_name
          }}</span>
          <span data-name="年龄：" :title="data.age">{{ data.age }}</span>
          <span data-name="学历：" :title="data.educ_name">{{
            data.educ_name
          }}</span>
          <span data-name="工作年限：" :title="data.job_years">{{
            data.job_years
          }}</span>
          <span data-name="所在城市：" :title="data.province + '-' + data.city"
            >{{ data.province }}-{{ data.city }}</span
          >
          <span data-name="联系电话：" :title="data.tel">{{ data.tel }}</span>
          <span data-name="电子邮箱：" :title="data.email">{{
            data.email
          }}</span>
          <span data-name="求职状态：" :title="data.job_status_name">{{
            data.job_status_name
          }}</span>
          <!-- <span
            v-if="data.salary_name != ''"
            data-name="目前薪水："
            :title="data.salary_name"
            >{{ data.salary_name }}</span
          > -->
          <!-- <span data-name="目前职位：">{{data.position_name}}</span> -->
        </div>
      </div>
    </section>
    <section class="details-b">
      <h1>求职意向</h1>
      <div
        v-for="item in data.wish_list"
        :key="item.id"
        style="width: 100%;margin-top:16px;display: flex;"
      >
        <span data-name="期望职能：">{{ item.wish_position_name[0] }}</span>
        <span data-name="期望城市："
          >{{ item.wish_province }} - {{ item.wish_city }}</span
        >
        <span data-name="期望薪资：">{{ item.wish_salary }}</span>
      </div>
    </section>
    <section class="details-e">
      <h1>教育经历</h1>
      <div class="project-box">
        <div v-for="item in data.educ_list" :key="item.id" class="project-item">
          <span data-name="学校：">{{ item.school }}</span>
          <span data-name="专业：">{{ item.major }}</span>
          <span data-name="起止时间："
            >{{ formatDateMm(item.start_time) }}-{{
              item.end_time === 1
                ? "至今"
                : formatDateMm(item.end_time)
            }}</span
          >
          <span data-name="学历：">{{ item.educ_name }}</span>
          <span data-name="是否全日制：">{{ item.full_name }}</span>
        </div>
      </div>
    </section>
    <section class="details-c">
      <h1>个人优势</h1>
      <div style="width: 100%;margin-top:16px;">
        <span>{{ data.intro }}</span>
      </div>
    </section>
    <section class="details-d">
      <h1>项目经历</h1>
      <div class="project-box">
        <div
          v-for="item in data.project_experience_list"
          :key="item.id"
          class="project-item"
        >
          <div class="project-item-top">
            <span data-name="项目名称：">{{ item.name }}</span>
            <span data-name="项目链接：">{{ item.link }}</span>
            <span data-name="角色：">{{ item.role }}</span>
            <span data-name="起止时间："
              >{{ formatDate(item.start_time) }}-{{
                item.end_time === 1
                  ? "至今"
                  : formatDate(item.end_time)
              }}</span
            >
          </div>
          <span style="margin: 0;" data-name="项目描述："></span>
          <p>{{ item.extra }}</p>
        </div>
      </div>
    </section>
    <section class="details-d">
      <h1>校园实习/工作经历</h1>
      <div class="project-box">
        <div
          v-for="item in data.project_list"
          :key="item.id"
          class="project-item"
        >
          <div class="project-item-top">
            <span data-name="公司名称：">{{ item.company }}</span>
            <span data-name="职位：">{{ item.position_name }}</span>
            <span data-name="所属部门：">{{ item.department }}</span>
            <span data-name="起止时间："
              >{{ formatDate(item.start_time) }}-{{
                item.end_time === 1
                  ? "至今"
                  : formatDate(item.end_time)
              }}</span
            >
          </div>
          <span style="margin: 0;" data-name="工作内容："></span>
          <p>{{ item.project }}</p>
        </div>
      </div>
    </section>
    <section class="details-h">
      <h1>技能水平</h1>
      <div style="width: 100%;margin-top:3px;">
        <div
          v-for="item in data.skill_list"
          :key="item.id"
          class="details-skill"
        >
          <span>{{ item.name }}：</span>
          <div v-show="item.level === 3">
            <p style="width: 100%">
              <a>{{ item.level_name }}</a>
            </p>
          </div>
          <div v-show="item.level === 2">
            <p style="width: 75%">
              <a>{{ item.level_name }}</a>
            </p>
          </div>
          <div v-show="item.level === 1">
            <p style="width: 50%">
              <a>{{ item.level_name }}</a>
            </p>
          </div>
          <div v-show="item.level === 0">
            <p style="width: 25%">
              <a>{{ item.level_name }}</a>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="details-g">
      <h1>作品展示</h1>
      <div class="project-box">
        <div v-for="item in data.opus_list" :key="item.id" class="project-item">
          <div class="project-item-top">
            <span data-name="作品名称：">{{ item.name }}</span>
            <span v-show="item.link" data-name="作品链接：">{{
              item.link
            }}</span>
          </div>
          <span
            v-show="item.attachment_content.length"
            data-name="作品图片："
          ></span>
          <div v-show="item.attachment_content.length" class="img-box">
            <div v-for="img in item.attachment_content" :key="img">
              <img :src="img" />
            </div>
          </div>
          <span style="margin: 0;" data-name="作品介绍："></span>
          <p>{{ item.intro }}</p>
        </div>
      </div>
    </section>
    <section class="details-f">
      <h1>兴趣特长</h1>
      <div style="width: 100%;margin-top:16px;">
        <span>{{ data.interest }}</span>
      </div>
    </section>
    <section class="details-j">
      <h1>荣誉奖项/资质证书</h1>
      <div style="display: flex;flex-wrap: wrap;width: 100%;margin-top:16px;">
        <p v-for="item in data.certificate_list" :key="item.id">
          <a
            class="img-box"
            style="background: #FDFDFD;"
            v-if="!item.attachment_content.length"
            >暂无证书</a
          >
          <a class="img-box" v-else v-for="img in item.attachment_content">
            <img :src="img" />
          </a>
          <span>{{ item.name }}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { formatDate } from "@/assets/js/public";
export default {
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    formatDateMm(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy.MM");
    },
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy.MM.dd");
    }
  }
};
</script>

<style scoped>
.userIf-box {
  width: 100%;
  display: flex;
  margin-top: 30px;
}
.userIf-left {
  width: 87px;
  height: 87px;
}
.userIf-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  margin-left: 30px;
}
/*  */
.details {
  display: flex;
  flex-flow: column;
  width: 1080px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 22px 30px;
}

/* 滚动条 */
.details::-webkit-scrollbar {
  width: 4px;
  background-color: #fff;
  border-radius: 2px;
}

.details::-webkit-scrollbar-thumb {
  background-color: #eee;
  border-radius: 2px;
}

.details section {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 0 30px 0;
  justify-content: flex-start;
  flex-flow: wrap;
}

/* 统一标题 */
.details section h1 {
  position: relative;
  display: flex;
  width: 100%;
  height: 36px;
  border-bottom: 1px solid #f5f6f9;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 13px;
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
}

.details section h1::before {
  content: "";
  position: absolute;
  width: 3px;
  height: 16px;
  background: #0077ff;
  left: 0;
  top: 2.5px;
  border-radius: 0 2px 2px 0;
}

.details section span {
  display: block;
  font-size: 14px;
  color: #333;
  overflow-wrap: break-word;
  white-space: pre-line;
  margin-bottom: 20px;
}

.details section span::before {
  content: attr(data-name);
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

.details section .project-item {
  width: 100%;
  margin-top: 16px;
  border-bottom: 1px solid #f5f6f9;
}
.details section .project-item:last-child {
  border: none;
}
.details section .project-box {
  width: 100%;
}
/* 内部样式a */
.details .details-a span {
  width: 33.33%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 内部样式b */
.details .details-b div {
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
}

.details .details-b div span {
  flex: 1;
  margin-right: 10px;
  /* width: 25%; */
}

/* 内部样式d */
.details .details-d .project-item {
  width: 100%;
  margin-top: 16px;
}
.details .details-d .project-item-top {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.details .details-d .project-item-top span {
  width: 25%;
  margin-right: 10px;
}

.details .details-d p {
  font-size: 14px;
  color: #333;
  padding-bottom: 16px;
  overflow-wrap: break-word;
  white-space: pre-line;
  line-height: 28px;
  margin-top: 7px;
}
/* 内部样式e */
.details .details-e div {
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
}

.details .details-e div span {
  display: block;
  width: 33.33%;
}
.details .details-g .project-item-top {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.details .details-g .project-item-top span {
  flex: 1;
}
.details .details-g .img-box {
  display: flex;
  padding-bottom: 16px;
}
.details .details-g .img-box div {
  width: 240px;
  height: 160px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.details .details-g .project-item img {
  max-width: 100%;
  max-height: 100%;
}
.details .details-g p {
  font-size: 14px;
  color: #333;
  padding-bottom: 16px;
  overflow-wrap: break-word;
  white-space: pre-line;
  line-height: 28px;
  margin-top: 7px;
}
.details-skill {
  display: flex;
  margin-top: 33px;
  align-items: baseline;
}
.details-skill span {
  margin-bottom: 0 !important;
  font-weight: bold;
}
.details-skill div {
  margin-left: 8px;
  width: 600px;
  height: 5px;
  background: #e4e7ed;
  border-radius: 3px;
}
.details-skill div p {
  height: 100%;
  background: #0077ff;
  border-radius: 3px;
  position: relative;
}
.details-skill div p a {
  padding: 4px;
  background: #0077ff;
  position: absolute;
  bottom: 10px;
  right: -16px;
  font-size: 12px;
  color: #fff;
}
.details-j div p {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}
.details-j div p .img-box {
  width: 300px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.details-j div p img {
  max-width: 100%;
  max-height: 100%;
}
.details-j div p span {
  font-size: 16px;
  font-family: MicrosoftYaHeiSemibold;
  color: #333333;
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Resume.vue